export default "__VITE_ASSET__8092028f__"